import EinstellungenUebersichtPage from './EinstellungenUebersichtPage';

export default EinstellungenUebersichtPage;
